export default __webpack_public_path__ + "static/media/fire.c1cd3869.svg";